/**
 * A memória do olhinho — UMA para o app inteiro (decisão de 09/10/2026: um
 * olho só, como no app do banco). Todas as telas cobertas leem e escrevem
 * aqui, então duas telas montadas nunca discordam: esconder em Vendas esconde
 * em Comissões, e o ícone de cada tela mostra sempre o mesmo estado.
 *
 * Fica num arquivo sem dependência nenhuma (nem do Supabase) de propósito:
 * o setup dos testes zera esta memória entre um teste e outro sem carregar o
 * cliente do banco. Quem conversa com o banco é o useValoresOcultos.
 */

export interface EstadoLoja {
  /** O que as telas mostram agora. Começa escondido (ver useValoresOcultos). */
  oculto: boolean;
  /** A preferência da pessoa ainda não chegou do banco. */
  carregando: boolean;
}

const INICIAL: EstadoLoja = { oculto: true, carregando: true };

export const loja = {
  estado: INICIAL,
  /** De quem é a preferência que está na memória (user_id). */
  dono: null as string | null,
  /** Conta os cliques: uma leitura que começou antes de um clique não o desfaz. */
  cliques: 0,
  /** Gravações ainda no ar: enquanto houver, a leitura não sobrescreve. */
  pendentes: 0,
  /** Leitura em andamento — duas telas abrindo juntas fazem UMA consulta. */
  leitura: null as Promise<void> | null,
};

const ouvintes = new Set<() => void>();

export const lerEstado = (): EstadoLoja => loja.estado;

export const assinar = (ouvinte: () => void) => {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
};

export const definirEstado = (parcial: Partial<EstadoLoja>) => {
  const novo = { ...loja.estado, ...parcial };
  if (novo.oculto === loja.estado.oculto && novo.carregando === loja.estado.carregando) return;
  loja.estado = novo;
  ouvintes.forEach((o) => o());
};

/** Volta ao começo: escondido, sem dono, nada lido. Usado pelos testes. */
export const reiniciarValoresOcultos = () => {
  loja.estado = INICIAL;
  loja.dono = null;
  loja.cliques = 0;
  loja.pendentes = 0;
  loja.leitura = null;
  ouvintes.forEach((o) => o());
};
